export enum GoogleModels {
  //gemma 1
  GEMMA = "gemma", //7b
  GEMMA_2B = "gemma:2b", //2b

  //gemma 2
  GEMMA2_2B = "gemma2:2b", //2b
  GEMMA2 = "gemma2", //9b
  GEMMA2_27B = "gemma2:27b", //27b

  //gemini 1.5
  GEMINI_1_5_FLASH = "gemini-1.5-flash",
  GEMINI_1_5_PRO = "gemini-1.5-pro",
  GEMINI_1_5_FLASH_LITE = "gemini-1.5-flash-lite",

  //gemini 2.0
  GEMINI_2_0_FLASH = "gemini-2.0-flash",
  GEMINI_2_0_FLASH_LITE = "gemini-2.0-flash-lite",

  //gemini 2.5
  GEMINI_2_5_PRO_EXP = "gemini-2.5-pro-exp-03-25",
  GEMINI_2_5_PRO_PREVIEW_05_06 = "gemini-2.5-pro-preview-05-06",
  GEMINI_2_5_FLASH_PREVIEW_05_20 = "gemini-2.5-flash-preview-05-20",
  GEMINI_2_5_FLASH_PREVIEW_04_17 = "gemini-2.5-flash-preview-04-17",
  GEMINI_FLASH_LATEST_BETA = "gemini-flash-latest-beta",
  GEMINI_PRO_LATEST_BETA = "gemini-pro-latest-beta",
  GEMINI_FLASH_LATEST_STABLE = "gemini-flash-latest-stable",
  GEMINI_PRO_LATEST_STABLE = "gemini-pro-latest-stable",
}

export const GoogleModelsEnabled = [
  GoogleModels.GEMINI_2_0_FLASH,
  GoogleModels.GEMINI_2_0_FLASH_LITE,
  GoogleModels.GEMINI_1_5_FLASH,
  GoogleModels.GEMINI_2_5_PRO_PREVIEW_05_06,
  GoogleModels.GEMINI_2_5_FLASH_PREVIEW_05_20,
  GoogleModels.GEMINI_2_5_FLASH_PREVIEW_04_17,
  GoogleModels.GEMINI_FLASH_LATEST_BETA,
  GoogleModels.GEMINI_PRO_LATEST_BETA,
  GoogleModels.GEMINI_FLASH_LATEST_STABLE,
  GoogleModels.GEMINI_PRO_LATEST_STABLE,
]

export const GoogleModelsLatestMap: {[key: string]: GoogleModels} = {
  [GoogleModels.GEMINI_FLASH_LATEST_BETA]: GoogleModels.GEMINI_2_5_FLASH_PREVIEW_05_20,
  [GoogleModels.GEMINI_PRO_LATEST_BETA]: GoogleModels.GEMINI_2_5_PRO_PREVIEW_05_06,
  [GoogleModels.GEMINI_FLASH_LATEST_STABLE]: GoogleModels.GEMINI_2_0_FLASH,
  [GoogleModels.GEMINI_PRO_LATEST_STABLE]: GoogleModels.GEMINI_1_5_PRO,
}
